var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAetna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18 C14 14 10 10 6 12 C2 14 2 20 6 24 L14 32 L22 24 C26 20 26 14 22 12 C18 10 14 14 14 18 Z",
    fill: "#2f3742"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 44,
    fontFamily: "Arial, sans-serif",
    fontSize: 38,
    fontWeight: 700,
    fill: "#2f3742",
    letterSpacing: -1
  }, "aetna")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAetna);
export default __webpack_public_path__ + "static/media/logo-aetna.6e1e447bb66bf374fd1a3565e5f7e16f.svg";
export { ForwardRef as ReactComponent };